import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0a6ee11c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0a6ee11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ee11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6ee11c')) {
      api.createRecord('0a6ee11c', component.options)
    } else {
      api.reload('0a6ee11c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=0a6ee11c&scoped=true&", function () {
      api.rerender('0a6ee11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hpz7ha947wRJ/JS/comp/Voucher.vue"
export default component.exports